module.exports = require("../utils/fn");


//////////////////
// WEBPACK FOOTER
// external "../utils/fn"
// module id = 2
// module chunks = 0 5